export var ETxnFilterSectionKeys;
(function (ETxnFilterSectionKeys) {
    ETxnFilterSectionKeys["actionFilter"] = "actionFilter";
    ETxnFilterSectionKeys["assetFilter"] = "assetFilter";
    ETxnFilterSectionKeys["txnTypeFilter"] = "txnTypeFilter";
})(ETxnFilterSectionKeys || (ETxnFilterSectionKeys = {}));
